import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import planbookCourseToggleAction from "cc-frontend/lib/actions/app-state/PLANBOOK_COURSE_TOGGLE"
import planbookLineUpClassesAction from "cc-frontend/lib/actions/app-state/PLANBOOK_LINE_UP_CLASSES"
import PLANBOOK_CHANGE_COURSE_ORDER from "cc-frontend/lib/actions/planbook/PLANBOOK_CHANGE_COURSE_ORDER"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { includes, map } from "lodash-es"
import styles from "./filter-classes.module.css"

interface FilterClassesSignature {
  Args: {
    toggleCourseId: (courseId: string) => void
    planbookId: string
    courses: Array<Course>
    hiddenCourseIds: Array<string>
    classesLinedUp: boolean
    toggleClassesLinedUp: Function
  }
}
export default class FilterClassesComponent extends Component<FilterClassesSignature> {
  @service declare dispatcher: Dispatcher

  readonly styles = styles
  isDragging = false

  @action
  changeClassOrder(_oldList, newList, draggedItem) {
    this.dispatcher.dispatchAction(PLANBOOK_CHANGE_COURSE_ORDER, {
      courseIds: map(newList, (course) => course.id),
      planbookId: this.args.planbookId,
    })
  }

  @action checkDragStart(event) {
    this.isDragging = !!event.target.closest(".js-handle")
  }

  @action localToggleCourseId(courseId: string, event) {
    // Don't toggle if you were dragging.
    if (this.isDragging) {
      this.isDragging = false
      return
    }

    let isTogglingOn = includes(this.args.hiddenCourseIds, courseId)
    this.dispatcher.dispatchPreparedAction(
      planbookCourseToggleAction({
        planbookId: this.args.planbookId,
        courseId: courseId,
        isTogglingOn: isTogglingOn,
      })
    )
    this.args.toggleCourseId(courseId)
  }
  @action localToggleClassesLinedUp() {
    this.args.toggleClassesLinedUp()
    this.dispatcher.dispatchPreparedAction(
      planbookLineUpClassesAction({
        planbookId: this.args.planbookId,
        classesLinedUp: this.args.classesLinedUp,
      })
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::FilterClasses": typeof FilterClassesComponent
  }
}
